"use strict";

exports.__esModule = true;
var HTML5NamedCharRefs = {};
exports.default = HTML5NamedCharRefs;